
import { useCallback, useEffect, useMemo } from 'react';

/**
 * Hook to manage task refetching logic
 */
export const useTaskRefetch = (
  dateRange: string,
  currentDate: Date,
  refetch?: () => void
) => {
  // Memoized refetch function to prevent unnecessary re-renders
  const refetchTasks = useCallback(() => {
    if (refetch) {
      // Force refetch even if within staleTime
      refetch();
    }
  }, [refetch]);

  // Consolidated effect for date/dateRange changes - only refetch once
  const shouldRefetch = useMemo(() => {
    return dateRange && currentDate && refetch;
  }, [dateRange, currentDate, refetch]);

  useEffect(() => {
    if (shouldRefetch) {
      // Debounce refetch to prevent multiple calls
      const timeoutId = setTimeout(() => {
        refetch();
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [shouldRefetch, refetch]);

  return {
    refetchTasks
  };
};
